// extracted by mini-css-extract-plugin
export default {"order":"OrderItem_order__XreUV","content":"OrderItem_content__zs1ZS"};